import { Component } from 'react';
import { connect } from 'react-redux';

import firebaseApp from './../../utils/firebase/firebase';

import {processDate, processProductDate} from './updateSystemActions';

export class UpdateSystem extends Component {

    componentDidMount = () => {
        firebaseApp.database().ref('utils/last_data_update_date').on('value', (snapshot) => {
            this.props.dispatch(processDate(snapshot.val()));
        });

        firebaseApp.database().ref('utils/last_product_update_date').on('value', (snapshot) => {
          this.props.dispatch(processProductDate(snapshot.val()));
        });
    }
    
    render(){
        return null;
    }
}
  
export default connect( null )(UpdateSystem);


// WEBPACK FOOTER //
// ./src/components/UpdateSystem/UpdateSystem.js